import { AddressValidationStatus } from "@omni/types/api/customer/cloud/shared/enums/addressValidationStatus.enum";
import { Translate } from "@omni/types/utils/translate";
import { useEffect } from "react";
import { Path, useFormContext } from "react-hook-form";

import { useAddressValidationContext } from "@/components/Address/AddressValidation/context/addressValidation.context";

import { useAddressFormBlockContext } from "../addressFormBlock.context";
import { DefaultAddressFormValues } from "../partials/defaultAddress.schema";

const useDefaultHook = () => {
    const { getValues, setValue, setError } =
        useFormContext<DefaultAddressFormValues>();
    const { displayAddressFields, validate, isValidating } =
        useAddressFormBlockContext();
    const { errorFields } = useAddressValidationContext();

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (errorFields.length > 0) {
            const values = getValues();

            const fieldErrors = errorFields.reduce(
                (acc, curr) => {
                    if (
                        values[curr.key as Path<DefaultAddressFormValues>] ===
                        curr.value
                    ) {
                        acc[curr.key] = () => (t: Translate) =>
                            t(`bpost.validation.invalid.field.${curr.key}`);
                    }
                    return acc;
                },
                {} as Record<string, () => (t: Translate) => string>
            );
            Object.entries(fieldErrors).forEach(([key, value]) => {
                setError(key as Path<DefaultAddressFormValues>, {
                    type: "validate",
                    message: value
                });
            });
        }
    }, [errorFields]);

    useEffect(() => {
        const address = getValues();

        validate(address, (addressLine) => {
            setValue("validationStatus", AddressValidationStatus.Validated);
            setValue("address", addressLine);
        });
    }, [getValues, setValue, validate]);

    useEffect(() => {
        setValue("selected", !displayAddressFields && !isValidating);
    }, [displayAddressFields, isValidating, setValue]);

    return {
        loading: isValidating
    };
};

export { useDefaultHook };
